import { RequireOnly } from '@pelicargo/types';
import { FreightService, Quote } from '@prisma/client';

import { INLAND_FREIGHT_SERVICES } from '../../constants';

export const isAfr = (quote: RequireOnly<Quote, 'freight_service'>) => {
  return quote?.freight_service === FreightService.AFR;
};
export const isExw = (quote: RequireOnly<Quote, 'freight_service'>) => {
  return quote?.freight_service === FreightService.EXW;
};
export const isFca = (quote: RequireOnly<Quote, 'freight_service'>) => {
  return quote?.freight_service === FreightService.FCA;
};
export const isInland = (quote: RequireOnly<Quote, 'freight_service'>) => {
  if (!quote?.freight_service) return null;
  return INLAND_FREIGHT_SERVICES.includes(quote?.freight_service);
};
